import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { convertTime } from 'containers/inProgressPage/helpers/convertTime';
import {
  SectionCountdown,
  SectionCountdownWrapper,
  TimerText
} from 'components/local/timer/styles/StyledComponents';

const Timer = ({ timedPortion, handleTimeout, handleReconciliation }) => {
  const [timeLeft, setTimeLeft] = useState(timedPortion.time_remaining);

  useEffect(() => {
    setTimeLeft(timedPortion.time_remaining);
  }, [timedPortion.time_remaining]);

  useEffect(() => {
    const currentTime = setTimeout(() => {
      if (timeLeft - 1 > 0) {
        setTimeLeft(timeLeft - 1);
      } else {
        handleTimeout();
      }
    }, 1000);
    return () => clearTimeout(currentTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft]);

  useEffect(() => {
    const driftCheck = setInterval(() => handleReconciliation(), 30000);
    return () => clearInterval(driftCheck);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SectionCountdownWrapper>
      <SectionCountdown>
        <Trans
          i18nKey="mcQuestion.timeRemaining"
          values={{ time: timeLeft ? convertTime(timeLeft) : '00:00:00' }}
          components={{
            1: <TimerText />
          }}
        />
      </SectionCountdown>
    </SectionCountdownWrapper>
  );
};

Timer.propTypes = {
  timedPortion: PropTypes.object.isRequired,
  handleTimeout: PropTypes.func.isRequired,
  handleReconciliation: PropTypes.func.isRequired
};

export default Timer;
